import { Box, Container, Typography } from "@mui/material";
import { HomeBg } from "assets/index";
import { useNavigate } from "react-router-dom";
import theme, { responsiveFontSize } from "themes/Theme";

const TermsConditionPage = () => {
  const navigate = useNavigate();
  return (
    <Box sx={styles.container}>
      <Box sx={styles.pageHeroBg}>
        <center>
          <Typography sx={styles.pageTitle}>Terms & Condition</Typography>
        </center>
      </Box>

      <Container
        sx={{
          borderRadius: 3,
          boxShadow: `rgba(125, 125, 125, 0.4) 0px 2px 9px 1px, rgba(200, 200, 200, 0.2) 0px 2px 9px 1px`,
          backgroundColor: "rgb(255, 255, 255)",
          p: 3,
          my: 3,
        }}
      >
        <Typography sx={styles.tabHeadingText}>1. Definitions</Typography>
        <ul>
          <li style={styles.tabDescText}>
            <strong>Platform Information:</strong> All data, materials, and
            information related to carbon removal protocols, methodologies, and
            related data accessed via the Carbon Plant LTD platform, including
            but not limited to technical, business, and operational information,
            proprietary methods, algorithms, software, know-how, and trade
            secrets.
          </li>

          <li style={styles.tabDescText}>
            <strong>Platform:</strong> The Carbon Plant LTD carbon exchange
            platform and any related websites, applications, or online services
            provided by Carbon Plant LTD.
          </li>

          <li style={styles.tabDescText}>
            <strong>User:</strong> Any individual or entity accessing the
            Platform.
          </li>

          <li style={styles.tabDescText}>
            <strong>Carbon Plant LTD, "we", "us", "our":</strong> Carbon Plant
            LTD.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>2. Introduction</Typography>
        <ul>
          <li style={styles.tabDescText}>
            These Terms of Service govern your access to and use of the Platform
            and the Platform Information. By accessing the Platform, you agree
            to be bound by these Terms.
          </li>
          <li style={styles.tabDescText}>
            Carbon Plant LTD owns, possesses, or controls certain proprietary
            Platform Information. The User agrees to access this information via
            the Platform, subject to these Terms.{" "}
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          3. Acceptance of Terms
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            By accessing and using the Platform, you acknowledge that you have
            read, understood, and agree to these Terms. If you do not agree, you
            must not use the Platform.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          4. Use of Platform Information
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            Users must not copy, sell, distribute, or exploit Platform
            Information for any competitive purposes, including the development,
            production, or marketing of competing products or services.
          </li>
          <li style={styles.tabDescText}>
            Users must protect Platform Information from unauthorized use,
            disclosure, or access, implementing appropriate security measures.
          </li>
          <li style={styles.tabDescText}>
            Users must promptly notify Carbon Plant LTD of any suspected or
            actual unauthorized use or breach.
          </li>
          <li style={styles.tabDescText}>
            Upon termination, Users must return or destroy all Platform
            Information as directed by Carbon Plant LTD.
          </li>
          <li style={styles.tabDescText}>
            These obligations survive termination for five (5) years.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          5. Intellectual Property
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            Platform Information remains the exclusive property of Carbon Plant
            LTD.
          </li>
          <li style={styles.tabDescText}>
            No rights to Platform Information are granted, except as explicitly
            stated herein.
          </li>
          <li style={styles.tabDescText}>
            Carbon Plant LTD's Protocols and Modules are subject to any stated
            licensing, and all other intellectual property rights, including
            patents, copyrights, trademarks, and trade secrets, remain with
            Carbon Plant LTD.
          </li>
          <li style={styles.tabDescText}>
            Users must not use Carbon Plant LTD's trademarks or logos without
            prior written consent.
          </li>
          <li style={styles.tabDescText}>
            Users must not reverse engineer, decompile, or attempt to derive the
            underlying information of the Platform Information.
          </li>
          <li style={styles.tabDescText}>
            Users must not modify, translate, or create derivative works without
            prior written consent.
          </li>
          <li style={styles.tabDescText}>
            User feedback on Platform Information becomes the property of Carbon
            Plant LTD.
          </li>
          <li style={styles.tabDescText}>
            Users must report any unauthorized use or infringement of Carbon
            Plant LTD's intellectual property.
          </li>
          <li style={styles.tabDescText}>
            These obligations survive termination indefinitely, as legally
            permissible.
          </li>
          <li style={styles.tabDescText}>
            Carbon Plant LTD may seek injunctive relief for breaches of this
            section.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          6. Term and Termination
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            These Terms commence upon User's first Platform access and continue
            until terminated.
          </li>
          <li style={styles.tabDescText}>
            Users may terminate by deleting their account and ceasing Platform
            use.
          </li>
          <li style={styles.tabDescText}>
            Either party may terminate for material breach if the other party
            fails to remedy the breach within 30 days of written notice.
          </li>
          <li style={styles.tabDescText}>
            Carbon Plant LTD may terminate immediately upon User insolvency or
            similar events.
          </li>
          <li style={styles.tabDescText}>
            Upon termination, Users must cease Platform use and return or
            destroy Platform Information.
          </li>
          <li style={styles.tabDescText}>
            Intellectual property and indemnification provisions survive
            termination.
          </li>
          <li style={styles.tabDescText}>
            Termination does not absolve prior obligations or liabilities.
          </li>
          <li style={styles.tabDescText}>
            Neither party is liable for damages from lawful termination.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          7. Breach and Liability
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            Unauthorized use of Platform Information may result in legal action.
          </li>
          <li style={styles.tabDescText}>
            Users indemnify Carbon Plant LTD for damages arising from breach of
            these Terms.
          </li>
          <li style={styles.tabDescText}>
            Carbon Plant LTD's liability will be limited to the maximum extent
            permissible under English law.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          8. Data Protection and Privacy
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            Both parties comply with applicable data protection laws, including
            the UK GDPR.
          </li>
          <li style={styles.tabDescText}>
            User personal data is used according to these Terms and Carbon Plant
            LTD's Privacy Policy.
          </li>
          <li style={styles.tabDescText}>
            Carbon Plant LTD implements appropriate security measures.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          9. Request for Information
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            Information requests are submitted to [contact form].
          </li>
          <li style={styles.tabDescText}>
            Responses are provided within 3-5 working days, subject to
            confidentiality.
          </li>
          <li style={styles.tabDescText}>
            More complex request response times will be communicated to the
            requestor.
          </li>
          <li style={styles.tabDescText}>
            This process also applies to requests to review or update Carbon
            Plant LTD Protocols.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>10. Force Majeure</Typography>
        <ul>
          <li style={styles.tabDescText}>
            Neither party is liable for delays due to events beyond their
            control (Force Majeure).
          </li>
          <li style={styles.tabDescText}>
            Affected parties must notify the other and attempt to resume
            performance.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>11. Governing Law</Typography>
        <ul>
          <li style={styles.tabDescText}>
            These Terms are governed by the laws of England and Wales.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>12. Entire Agreement</Typography>
        <ul>
          <li style={styles.tabDescText}>
            These Terms constitute the entire agreement, superseding prior
            agreements.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>
          13. Contact Information
        </Typography>
        <ul>
          <li style={styles.tabDescText}>
            Contact{" "}
            <span
              style={{
                cursor: "pointer",
                color: theme.palette.primary.light,
              }}
              onClick={() => {
                navigate("/contact-us");
              }}
            >
              [Contact Us]
            </span>{" "}
            for questions or notices.
          </li>
        </ul>

        <Typography sx={styles.tabHeadingText}>14. Acknowledgment</Typography>
        <ul>
          <li style={styles.tabDescText}>
            By using the Platform, you acknowledge and agree to these Terms.
          </li>
        </ul>
      </Container>
    </Box>
  );
};
export default TermsConditionPage;
const styles = {
  container: {
    minHeight: "100vh",
  },
  pageHeroBg: {
    backgroundImage: `url(${HomeBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderBottomLeftRadius: "50px",
    borderBottomRightRadius: "50px",
    width: "100%",
    padding: "1em",
  },
  pageTitle: {
    py: 15,
    fontSize: responsiveFontSize(75),
    fontWeight: 400,
    color: theme.palette.custom.white,
  },
  tabHeadingText: {
    fontSize: responsiveFontSize(22),
    color: theme.palette.text.primary,
    fontWeight: 400,
    marginTop: 2,
  },
  tabDescText: {
    fontSize: responsiveFontSize(15),
    color: theme.palette.text.primary,
    fontWeight: 400,
    ml: 3,
  },
};
